import { computed, Directive, input } from '@angular/core';
import { cva, VariantProps } from 'class-variance-authority';
import * as fromHelpers from '../../helpers';

export enum SpinnerSizeVariant {
  xs = 'xs',
  sm = 'sm',
  md = 'md',
}

export enum SpinnerColorVariant {
  primary = 'primary',
  white = 'white',
}

export const spinnerVariants = cva(
  fromHelpers.cn('rounded-full animate-spin', 'mask-[radial-gradient(circle_at_center,_transparent_48%,_black_52%)]'),
  {
    variants: {
      size: {
        [`${SpinnerSizeVariant.xs}`]: 'size-16',
        [`${SpinnerSizeVariant.sm}`]: 'size-24', // default
        [`${SpinnerSizeVariant.md}`]: 'size-32',
      },
      color: {
        [`${SpinnerColorVariant.primary}`]:
          'bg-[conic-gradient(from_90deg,_var(--color-transparency-primary-5)_0deg,_var(--color-primary-500)_360deg)]',
        [`${SpinnerColorVariant.white}`]:
          'bg-[conic-gradient(from_90deg,_var(--color-transparency-white-5)_0deg,_var(--color-shades-white)_360deg)]',
      },
    },
    defaultVariants: {
      size: SpinnerSizeVariant.sm,
      color: SpinnerColorVariant.primary,
    },
  },
);
export type SpinnerVariants = VariantProps<typeof spinnerVariants>;

@Directive({
  selector: '[dmcomSpinner]',
  standalone: true,
  host: {
    '[class]': 'className()',
    role: 'status',
  },
})
export class SpinnerDirective {
  readonly size = input<SpinnerVariants['size']>();
  readonly color = input<SpinnerVariants['color']>();

  protected readonly className = computed(() => fromHelpers.cn(spinnerVariants({ size: this.size(), color: this.color() })));
}
